import formModel from './formModel';

const {
    formField: {
        password
    }
} = formModel;


export default {
    [password.name]: '',
};
